(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* -------------------------------------------------------------
     Hash scroll (safe, static)
     ------------------------------------------------------------- */
  {
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) card.scrollIntoView({ behavior: 'instant' });
        },
        { once: true }
      );
    }
  }

  /* -------------------------------------------------------------
     Infinite scroll (manual fetch + append)
     ✅ FIX for MOBILE: IntersectionObserver sentinel (loads before footer)
     - Keeps scroll fallback
     - Early skeleton + earlier load trigger
     - Adds "Cargando más productos..." + spinner ABOVE skeletons (inside the grid)
     ------------------------------------------------------------- */
  (function () {
    if (window.__COLLECTION_INF_FETCH__) return;
    window.__COLLECTION_INF_FETCH__ = true;

    function getResultsList() {
      const lists = document.querySelectorAll('#ResultsList');
      if (!lists || !lists.length) return null;
      for (const el of lists) {
        if (el.offsetParent !== null) return el;
      }
      return lists[0];
    }

    const STATE = (window.__COLLECTION_INF_FETCH_STATE__ =
      window.__COLLECTION_INF_FETCH_STATE__ || {
        loading: false,
        lastHref: null,
        lockUntil: 0,
        scrollAttached: false,
        earlySkeletonShownForHref: null,
        prefetchedHref: null,
        ioAttached: false,
        io: null
      });

    const SAFETY_TIMEOUT = 15000;

    // Thresholds (distance from bottom in px) - scroll fallback
    const SKELETON_EARLY_THRESHOLD = 2200; // show message + skeleton earlier
    const LOAD_THRESHOLD = 2100; // start loading earlier
    const HARD_THRESHOLD = 450; // hard fallback very near bottom

    const SKELETON_COUNT = 8;

    function enablePaginationIsOn(resultsList) {
      return resultsList && resultsList.dataset.enablePagination === 'true';
    }

    function getNextLinkEl(resultsList) {
      return resultsList.querySelector('link[rel="next"]');
    }

    function getNextAnchorEl(resultsList) {
      return resultsList.querySelector('.pagination__next[rel="next"]');
    }

    function getNextHref(resultsList) {
      const link = getNextLinkEl(resultsList);
      return link ? link.getAttribute('href') : null;
    }

    function hasNextPage(resultsList) {
      return !!getNextHref(resultsList);
    }

    function findGridContainer(resultsList) {
      const firstItem = resultsList.querySelector('li.product-grid__item');
      return firstItem ? firstItem.parentElement : null;
    }

    function getSentinel(resultsList) {
      return resultsList.querySelector('[data-inf-sentinel]');
    }

    function pxFromBottom() {
      const docHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scrollPos = window.innerHeight + window.pageYOffset;
      return docHeight - scrollPos;
    }

    /* ----------------------------
       Loading message (in-grid)
       ---------------------------- */
    function showLoadingMessage(resultsList) {
      const grid = findGridContainer(resultsList);
      if (!grid) return;

      // Avoid duplicates
      if (grid.querySelector('[data-loading-message]')) return;

      const li = document.createElement('li');
      li.setAttribute('data-loading-message', '');
      li.className = 'product-grid__item product-grid__item--loading';
      li.setAttribute('role', 'status');
      li.setAttribute('aria-live', 'polite');

      li.innerHTML = `
        <div class="inf-scroll__msg">
          <span class="inf-scroll__spinner" aria-hidden="true"></span>
          <span class="inf-scroll__text">Cargando más productos...</span>
        </div>
      `;

      // Append at the end of the grid so it appears "above" skeletons
      grid.appendChild(li);
    }

    function hideLoadingMessage(resultsList) {
      const grid = findGridContainer(resultsList);
      if (!grid) return;
      const msg = grid.querySelector('[data-loading-message]');
      if (msg) msg.remove();
    }

    /* ----------------------------
       Skeletons
       ---------------------------- */
    function removeSkeletons(resultsList) {
      resultsList.querySelectorAll('[data-skeleton]').forEach((el) => el.remove());
      hideLoadingMessage(resultsList);
      resultsList.removeAttribute('aria-busy');
      STATE.earlySkeletonShownForHref = null;
    }

    function addSkeletons(resultsList, count = SKELETON_COUNT) {
      const grid = findGridContainer(resultsList);
      if (!grid) return;

      // avoid duplicates
      if (grid.querySelector('[data-skeleton]')) return;

      // Show message + spinner first
      showLoadingMessage(resultsList);

      resultsList.setAttribute('aria-busy', 'true');

      const frag = document.createDocumentFragment();
      for (let i = 0; i < count; i++) {
        const li = document.createElement('li');
        li.className = 'product-grid__item product-grid__item--skeleton';
        li.setAttribute('data-skeleton', '');
        li.setAttribute('aria-hidden', 'true');
        li.innerHTML = `
          <div class="skeleton-card group-block">
            <div class="skeleton-media skeleton-animate"></div>
            <div class="skeleton-content">
              <div class="skeleton-line skeleton-animate"></div>
              <div class="skeleton-line skeleton-animate short"></div>
              <div class="skeleton-line skeleton-animate price"></div>
            </div>
          </div>`;
        frag.appendChild(li);
      }
      grid.appendChild(frag);
    }

    /* ----------------------------
       DOM update helpers
       ---------------------------- */
    function updateNextFromDoc(resultsList, doc) {
      const newLink =
        doc.querySelector('#ResultsList link[rel="next"]') || doc.querySelector('link[rel="next"]');

      const newHref = newLink ? newLink.getAttribute('href') : null;

      const currentLink = getNextLinkEl(resultsList);
      const currentAnchor = getNextAnchorEl(resultsList);

      if (!newHref) {
        if (currentLink) currentLink.remove();
        if (currentAnchor) currentAnchor.remove();
        return;
      }

      if (currentLink) {
        currentLink.setAttribute('href', newHref);
        currentLink.removeAttribute('data-prefetched');
      } else {
        const link = document.createElement('link');
        link.setAttribute('rel', 'next');
        link.setAttribute('href', newHref);
        resultsList.appendChild(link);
      }

      if (currentAnchor) {
        currentAnchor.setAttribute('href', newHref);
      } else {
        const a = document.createElement('a');
        a.className = 'pagination__next';
        a.setAttribute('rel', 'next');
        a.setAttribute('href', newHref);
        a.setAttribute('hidden', '');
        a.setAttribute('aria-hidden', 'true');
        a.setAttribute('tabindex', '-1');
        a.textContent = 'Next';
        resultsList.appendChild(a);
      }
    }

    function appendProductsFromDoc(resultsList, doc) {
      const grid = findGridContainer(resultsList);
      if (!grid) return 0;

      const incomingFirst =
        doc.querySelector('#ResultsList li.product-grid__item') || doc.querySelector('li.product-grid__item');

      if (!incomingFirst) return 0;

      const incomingGrid = incomingFirst.parentElement;
      if (!incomingGrid) return 0;

      // ✅ prevent duplicating sentinel from incoming HTML
      incomingGrid.querySelectorAll('[data-inf-sentinel]').forEach((n) => n.remove());

      const items = incomingGrid.querySelectorAll('li.product-grid__item');
      if (!items.length) return 0;

      // Remove loading message BEFORE appending products (so it doesn't sit between pages)
      hideLoadingMessage(resultsList);

      const frag = document.createDocumentFragment();
      items.forEach((li) => {
        // avoid duplicate IDs after append
        if (li.id && document.getElementById(li.id)) li.removeAttribute('id');
        frag.appendChild(li);
      });

      grid.appendChild(frag);
      return items.length;
    }

    /* ----------------------------
       Prefetch
       ---------------------------- */
    function maybePrefetch(resultsList) {
      const href = getNextHref(resultsList);
      if (!href) return;
      if (STATE.prefetchedHref === href) return;

      STATE.prefetchedHref = href;

      try {
        const l = document.createElement('link');
        l.rel = 'prefetch';
        l.as = 'document';
        l.href = href;
        document.head.appendChild(l);
      } catch (e) {}
    }

    /* ----------------------------
       Early message+skeleton
       ---------------------------- */
    function maybeShowEarlySkeleton(resultsList) {
      if (STATE.loading) return;
      if (!hasNextPage(resultsList)) return;

      const href = getNextHref(resultsList);
      if (!href) return;

      // show once per href
      if (STATE.earlySkeletonShownForHref === href) return;

      const dist = pxFromBottom();
      if (dist < SKELETON_EARLY_THRESHOLD) {
        addSkeletons(resultsList);
        STATE.earlySkeletonShownForHref = href;
      }
    }

    /* ----------------------------
       IntersectionObserver (MOBILE FIX)
       ---------------------------- */
    function attachIntersectionObserver(resultsList) {
      if (!('IntersectionObserver' in window)) return;
      if (STATE.ioAttached) return;

      const sentinel = getSentinel(resultsList);
      if (!sentinel) return;

      STATE.io = new IntersectionObserver(
        (entries) => {
          const hit = entries && entries.some((e) => e.isIntersecting);
          if (!hit) return;

          if (!STATE.loading && hasNextPage(resultsList)) {
            loadNextPage(false);
          }
        },
        {
          root: null,
          // loads BEFORE user reaches footer (tune if needed)
          rootMargin: '1400px 0px 800px 0px',
          threshold: 0
        }
      );

      STATE.io.observe(sentinel);
      STATE.ioAttached = true;
    }

    /* ----------------------------
       Fetch + append
       ---------------------------- */
    async function loadNextPage(force = false) {
      const resultsList = getResultsList();
      if (!resultsList) return;

      if (enablePaginationIsOn(resultsList)) return;

      const now = Date.now();
      if (STATE.loading) return;
      if (!force && now < STATE.lockUntil) return;

      const href = getNextHref(resultsList);
      if (!href) return;

      // Prevent same-href loop
      if (STATE.lastHref === href) {
        STATE.lockUntil = now + 1200;
        return;
      }

      STATE.loading = true;
      STATE.lastHref = href;

      // Ensure message + skeletons are visible immediately
      addSkeletons(resultsList);

      const ctrl = new AbortController();
      const timeoutId = setTimeout(() => ctrl.abort(), SAFETY_TIMEOUT);

      try {
        const res = await fetch(href, { credentials: 'same-origin', signal: ctrl.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Remove skeleton/message before inserting products
        removeSkeletons(resultsList);

        const appended = appendProductsFromDoc(resultsList, doc);
        updateNextFromDoc(resultsList, doc);

        // Re-attach IO if needed (sentinel exists in DOM, but safe to ensure)
        attachIntersectionObserver(resultsList);

        if (appended === 0) {
          STATE.lockUntil = Date.now() + 2000;
        } else {
          STATE.lockUntil = Date.now() + 400;
        }
      } catch (e) {
        removeSkeletons(resultsList);
        STATE.lockUntil = Date.now() + 2500;
      } finally {
        clearTimeout(timeoutId);
        STATE.loading = false;
      }
    }

    /* ----------------------------
       Scroll handler (fallback)
       ---------------------------- */
    function onScroll() {
      const resultsList = getResultsList();
      if (!resultsList) return;
      if (enablePaginationIsOn(resultsList)) return;

      const dist = pxFromBottom();

      // Prefetch earlier (no UI impact)
      if (dist < 2600) maybePrefetch(resultsList);

      // Show message + skeleton earlier
      maybeShowEarlySkeleton(resultsList);

      // Start loading earlier
      if (!STATE.loading && hasNextPage(resultsList) && dist < LOAD_THRESHOLD) {
        loadNextPage(false);
        return;
      }

      // Hard fallback very near bottom
      if (!STATE.loading && hasNextPage(resultsList) && dist < HARD_THRESHOLD) {
        loadNextPage(true);
      }
    }

    function start() {
      const resultsList = getResultsList();
      if (!resultsList) return;
      if (enablePaginationIsOn(resultsList)) return;

      // ✅ MOBILE FIX: sentinel observer
      attachIntersectionObserver(resultsList);

      // If page is short, show earlier + load
      maybePrefetch(resultsList);
      maybeShowEarlySkeleton(resultsList);

      const dist = pxFromBottom();
      if (hasNextPage(resultsList) && dist < LOAD_THRESHOLD) {
        loadNextPage(true);
      }
    }

    if (!STATE.scrollAttached) {
      window.addEventListener('scroll', onScroll, { passive: true });
      STATE.scrollAttached = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
